'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _AssetManagers = require('./AssetManagers.css');

var _AssetManagers2 = _interopRequireDefault(_AssetManagers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetManagers = (_dec = (0, _reactCssModules2.default)(_AssetManagers2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AssetManagers, _Component);

  function AssetManagers(props) {
    (0, _classCallCheck3.default)(this, AssetManagers);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AssetManagers.__proto__ || (0, _getPrototypeOf2.default)(AssetManagers)).call(this, props));

    var allFams = _config2.default.formOptions.fundFamilyAll;
    var filteredFams = allFams.reduce(function (arr, el) {
      if (el.name !== 'All funds') {
        arr.push(el);
      }
      return arr;
    }, []);

    _this.state = {
      filteredFams: filteredFams,
      title: 'Asset managers',
      description: 'We analyze the mutual funds of major asset managers managers funds to measure their investments in sustainability risk sectors.',
      url: _config2.default.domain + _config2.default.routes.assetManagers
    };
    return _this;
  }

  (0, _createClass3.default)(AssetManagers, [{
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'p',
              null,
              'Retirement plans are usually based around funds from major asset managers like Vanguard, BlackRock, and Fidelity. We analyze these managers\' funds to measure their investments in sustainability risk sectors. Choose an asset manager below to see how their funds are rated on fossil fuels. We also have data on asset managers for ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://deforestationfreefunds.org/families' },
                'deforestation'
              ),
              ', as well as social issues like ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://genderequalityfunds.org/families' },
                'gender equality'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://gunfreefunds.org/families' },
                'civilian firearms'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://prisonfreefunds.org/families' },
                'the prison industrial complex'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://weaponfreefunds.org/families' },
                'arms manufacturers and military contractors'
              ),
              ', and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://tobaccofreefunds.org/families' },
                'tobacco'
              ),
              '.'
            )
          ),
          _react2.default.createElement(_components.FamilyGrid, null),
          _react2.default.createElement(
            'nav',
            null,
            this.state.filteredFams.map(function (el, ix) {
              return _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.fff + '/families?q=' + el.name,
                  title: el.name,
                  key: el.name
                },
                _react2.default.createElement(
                  'h2',
                  { styleName: 'addtl-fam-link' },
                  el.name
                )
              );
            })
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return AssetManagers;
}(_react.Component)) || _class);
exports.default = AssetManagers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AssetManagers/AssetManagers.js
// module id = 1462
// module chunks = 0